function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_441",
  "data-name": "Group 441",
  transform: "translate(-903 -1117.637)"
}, React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1117.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-2",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1117.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-3",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1117.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-4",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1117.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-5",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1117.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-6",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1117.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-7",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1155.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-8",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1155.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-9",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1155.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-10",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1155.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-11",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1155.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-12",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1155.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-13",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1193.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-14",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1193.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-15",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1193.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-16",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1193.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-17",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1193.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-18",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1193.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-19",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1231.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-20",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1231.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-21",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1231.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-22",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1231.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-23",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1231.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-24",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1231.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-25",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1269.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-26",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1269.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-27",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1269.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-28",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1269.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-29",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1269.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-30",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1269.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-31",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1307.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-32",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1307.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-33",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1307.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-34",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1307.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-35",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1307.637)"
}), React.createElement("circle", {
  id: "Ellipse_32-36",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1307.637)"
}), React.createElement("g", {
  id: "Group_578",
  "data-name": "Group 578",
  transform: "translate(-1005.493 118.316)"
}, React.createElement("ellipse", {
  id: "Ellipse_1310",
  "data-name": "Ellipse 1310",
  cx: 13.5,
  cy: 13.5,
  rx: 13.5,
  ry: 13.5,
  transform: "translate(1990.166 1040.683)",
  fill: "#ff525f"
}), React.createElement("ellipse", {
  id: "Ellipse_1311",
  "data-name": "Ellipse 1311",
  cx: 13.5,
  cy: 13.5,
  rx: 13.5,
  ry: 13.5,
  transform: "translate(2020.339 1042.683)",
  fill: "#937ef8"
}), React.createElement("path", {
  id: "Path_1124",
  "data-name": "Path 1124",
  d: "M1977.213,1023.4c-3.389.527-5.773,4.612-5.429,8.024.969,9.593,5.812,44.163,4.131,52.721-.331,1.682-2.272,1.923-12.015-10.66-7.156-9.241-11.892-18.067-14.645-20.522-4.847-4.323-11.993-.763-7.146,8.279,6.613,12.338,17.652,30.724,21.059,40.092,2.675,7.357,3.963,22.617,6.675,31.607s5.424,19.382,5.875,24.355,0,24.888,0,24.888h45.188s.462-19.511,1.819-23.579c.906-2.719,2.015-9.132,6.559-12.639,2.465-1.905,5.561-4.058,9.435-6.627,4.751-3.151,9.93-6.855,12.36-15.632,2.386-8.617,7.976-18.081,17.067-25.884.853-.59,7.052-4.878,8.743-6.288-.309-2.307-1.771-8.2-14.177-5.332-9.815,2.269-23,21.262-26.758,24.418-3.843,3.224-6.929,1.938-6.882-3.489.168-6.626.5-13.586,1.165-15.6,1.919-5.817,8.607-31.552,14.346-57.348,2.179-9.792-6.322-15.794-11.466-4.068-4.235,9.657-10.138,35.807-14.667,46.854-.1.243-.2.451-.3.668-.558,1.17-1.8,3.378-2.832,2.4-1.653-1.572-2.322-4.482-2.494-5.372-1.238-14.085-1.587-37.019-.826-46.971,1.109-14.515-10.932-16.617-13.384-2.207-.608,3.578-.4,17.9-.922,29.7-.427,9.735-.223,16.27-.988,20.882-.989,5.968-5.169,2.716-6.573-1.2-1.475-4.114-1.844-8.529-2.2-12.885-.65-7.947-2.1-24.387-3.525-33.368a6.293,6.293,0,0,0-7.193-5.22Z",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
})));

var SvgCsAndGsr = function SvgCsAndGsr(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCsAndGsr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cs-and-gsr.578d768e.svg";
export { ForwardRef as ReactComponent };